module.exports = "<xo-generic-error token=token></xo-generic-error>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./pages/xo-generic-error/template.html
 ** module id = 210
 ** module chunks = 1
 **/